import styled from "@emotion/styled";
import { CertificationPassword } from "components/password/CertificationPassword";
import useTranslation from "hooks/useTranslation";

import { FormProvider, useForm } from "react-hook-form";

export const NormalPassword = () => {
  const methods = useForm({
    mode: "onTouched",
  });
  const isEnglishPage = useTranslation();
  return (
    <Wrapper>
      <div>
        <p>
          &middot;{" "}
          {isEnglishPage
            ? "You must verify your identity to reset your password."
            : "비밀번호 재설정을 위해 본인 인증이 필요합니다."}
        </p>
        <p>
          &middot;{" "}
          {isEnglishPage
            ? "Enter your registered mobile number to receive a verification message."
            : "아래에 휴대폰 번호를 입력하시면 문자 메시지로 인증 링크를 전송해드립니다."}
        </p>
      </div>
      <FormProvider {...methods}>
        <CertificationPassword name="phoneNumber" memberType="normal" />
      </FormProvider>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  > div:first-of-type {
    ${({ theme }) => theme.font.Caption}
  }
`;
